import { styled } from '@linaria/react'
import React, { FC } from 'react'
import { useAppContext } from '../contexts/App.context'
import { ButtonRegular } from '../ui/Button'

export const LanguagePage: FC = () => {
  const { basePath } = useAppContext()

  const handleLanguageChange = (language: string) => {
    localStorage.setItem('language', language)
    window.location.href = basePath
  }

  return (
    <LanguagePageContainer>
      <ButtonRegular onClick={() => handleLanguageChange('ru')}>
        Русский
      </ButtonRegular>

      <ButtonRegular onClick={() => handleLanguageChange('en')}>
        English
      </ButtonRegular>
    </LanguagePageContainer>
  )
}

const LanguagePageContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-content: center;
  margin-bottom: calc(var(--bottom-navigation-height) * -1);
`

export const languagePagePath = '/language'
